import type { IconSvgObject } from './types';

const PictureInPicture01Icon: IconSvgObject = [
  ["path", { d: "M6.99219 19.965C5.11989 19.8873 3.97194 19.6366 3.16376 18.8284C1.99219 17.6569 1.99219 15.7712 1.99219 12C1.99219 8.22876 1.99219 6.34315 3.16376 5.17157C4.33534 4 6.22095 4 9.99219 4H13.9922C17.7634 4 19.6491 4 20.8206 5.17157C21.4738 5.82475 21.7628 6.69989 21.8907 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.9297 12H13.0547C11.9156 12 10.9922 12.8954 10.9922 14V18C10.9922 19.1046 11.9156 20 13.0547 20H19.9297C21.0688 20 21.9922 19.1046 21.9922 18V14C21.9922 12.8954 21.0688 12 19.9297 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default PictureInPicture01Icon;
